import LockTableCellRenderer from "./LockTableCellRenderer";
import messageResource from "../../messageResource";
import {escapeHtmlSymbols} from "../../atUtils";

export default class UserNameCellRenderer extends LockTableCellRenderer {
    generateContent(cell) {
        var userBean = cell.getValue();
        var cellRow = cell.getRow();

        var expandCollapseDivClassNames = [];
        var expandCollapseDiv = document.createElement("div");
        if (cellRow.getChildRows().length > 0) {
            expandCollapseDivClassNames.push("expandCollapse");
            expandCollapseDiv.onclick = function() {
                cellRow.changeExpandCollapse();
            };
        }
        else if (!cellRow.hasData) {
            cell.getCellEl().title = messageResource.getMessage("lock_tt.table.tooltip.user_without_tt");
            if (!LockTTStore.isHideDetailsOnLockTT()) {
                expandCollapseDivClassNames.push("userWithoutTt");
            }
        }

        if (userBean.isActive())
            expandCollapseDivClassNames.push("activeUserName");
        expandCollapseDivClassNames.push("lockTableEllipsis");

        expandCollapseDiv.className = expandCollapseDivClassNames.join(" ");
        expandCollapseDiv.innerHTML = ['&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;', escapeHtmlSymbols(userBean.formatNameLFM())].join('');
        cell.getCellEl().appendChild(expandCollapseDiv);
    }

    getCellClassName(cell) {
        var cssClass = "userCell";
        if (this.getSelectionController(cell).isRowIncludedIntoSelection(cell.getRow().getRowIdx()))
            cssClass += "MarkSelection";
        if (cell.getRow().isExpanded())
            cssClass += "Expanded";

        return cssClass;
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/renderers/UserNameCellRenderer.js